import { render, staticRenderFns } from "./BulkSchemaCreate.vue?vue&type=template&id=7c5701e6&scoped=true"
import script from "./BulkSchemaCreate.vue?vue&type=script&lang=ts"
export * from "./BulkSchemaCreate.vue?vue&type=script&lang=ts"
import style0 from "./BulkSchemaCreate.vue?vue&type=style&index=0&id=7c5701e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5701e6",
  null
  
)

export default component.exports